/**
 * Modelos Deenex (`/activa/oficial/plantillas/modelos`).
 *
 * Una página y no un cajón encima de la lista: se elige mirando las previas a lo ancho, y el «atrás»
 * del navegador desde el editor vuelve acá en vez de a una lista con la galería cerrada. Cada modelo
 * lleva al editor de siempre con `?modelo=` (la galería sin `onElegir` ya arma ese link).
 */

import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { GaleriaModelos } from "../components/GaleriaModelos";

const R = "/activa/oficial";

export default function PlantillasModelosPage() {
  return (
    <div className="space-y-5">
      <Link to={`${R}/plantillas`} className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-800"><ArrowLeft size={14} /> Plantillas</Link>
      <div>
        <h2 className="text-lg font-semibold text-slate-900 tracking-tight">Modelos Deenex</h2>
        <p className="text-xs text-slate-500 mt-0.5">Ya pasan las reglas de Meta. Elegí uno y ajustalo a tu marca.</p>
      </div>
      <GaleriaModelos />
    </div>
  );
}
